function showSearchOverlay() {
  const overlay = document.querySelector('[data-search-overlay]');
  // allow transition
  overlay.setAttribute('data-search-overlay-fade', true);
  overlay.setAttribute('data-search-overlay-visible', true);
  // trigger transition
  setTimeout(() => {
    overlay.removeAttribute('data-search-overlay-fade');
  }, 1);
  // add no-scroll body class
  document.body.classList.add('has-overlay');
}

function hideSearchOverlay() {
  const overlay = document.querySelector('[data-search-overlay]');
  // trigger transition
  overlay.setAttribute('data-search-overlay-fade', true);
  // finish transition
  window.setTimeout(() => {
    overlay.removeAttribute('data-search-overlay-fade');
    overlay.removeAttribute('data-search-overlay-visible');
  }, 300);

  // remove no-scroll body class
  document.body.classList.remove('has-overlay');
}

export default { showSearchOverlay, hideSearchOverlay };

document.querySelectorAll('[data-search-overlay-show]').forEach((button) => {
  button.addEventListener('click', showSearchOverlay);
});

document.querySelectorAll('[data-search-overlay-hide]').forEach((button) => {
  button.addEventListener('click', hideSearchOverlay);
});
